import { Mark } from '@tiptap/core'
import { Plugin, PluginKey } from '@tiptap/pm/state'
import { ReplaceStep } from '@tiptap/pm/transform'

export const ChunkMark = Mark.create({
  name: 'chunk',

  inclusive: false,

  addAttributes() {
    return {
      chunkId: {
        default: null,
        parseHTML: (element: HTMLElement) => element.getAttribute('data-chunk-id'),
        renderHTML: (attrs: Record<string, any>) => (attrs['chunkId'] ? { 'data-chunk-id': attrs['chunkId'] } : {}),
      },
    }
  },

  parseHTML() {
    return [
      {
        tag: 'span[data-chunk-id]',
      },
    ]
  },

  renderHTML({ HTMLAttributes }) {
    return ['span', HTMLAttributes, 0]
  },

  addProseMirrorPlugins() {
    const chunkMarkType = this.type

    return [
      new Plugin({
        key: new PluginKey('chunkSplitCleanup'),

        appendTransaction(transactions, _oldState, newState) {
          const hasStructuralChange = transactions.some((transaction) =>
            transaction.steps.some((step) => step instanceof ReplaceStep && (step.slice.openStart > 0 || step.slice.openEnd > 0))
          )

          if (!hasStructuralChange) {
            return null
          }

          const tr = newState.tr

          // Track which block position each chunkId first appears in.
          // If the same chunkId appears in a different block (after a split), strip it.
          const firstBlockByChunkId = new Map<string, number>()
          const rangesToStrip: { from: number; to: number }[] = []

          newState.doc.descendants((node, pos) => {
            if (!node.isBlock || !node.inlineContent) {
              return true
            }

            node.descendants((child, childPos) => {
              if (!child.isText) {
                return true
              }

              const chunkMark = child.marks.find((mark) => mark.type === chunkMarkType) ?? null

              if (chunkMark === null || chunkMark.attrs['chunkId'] === null) {
                return false
              }

              const chunkId = chunkMark.attrs['chunkId'] as string
              const firstBlock = firstBlockByChunkId.get(chunkId) ?? null

              if (firstBlock === null) {
                firstBlockByChunkId.set(chunkId, pos)
              } else if (firstBlock !== pos) {
                rangesToStrip.push({ from: pos + childPos + 1, to: pos + childPos + 1 + child.nodeSize })
              }

              return false
            })

            return false
          })

          for (const range of rangesToStrip) {
            tr.removeMark(range.from, range.to, chunkMarkType)
          }

          return rangesToStrip.length > 0 ? tr : null
        },
      }),
    ]
  },
})
